import React, { useCallback } from "react";

// atoms
import { ConcretingButton } from "@atoms/index";

// Libraries
import { Grid } from "@libraries/mui";

// Languages
import { ConcretingMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";

import * as Styled from "./styles";

export type IConcretingControllerDate = "today" | "past" | "future";

interface Props {
  concretingControllerDate: IConcretingControllerDate;
  setConcretingControllerDate: React.Dispatch<
    React.SetStateAction<IConcretingControllerDate>
  >;
}

const ConcretingButtons: React.FC<Props> = ({
  concretingControllerDate,
  setConcretingControllerDate
}) => {
  const { t } = useTranslation();

  const handleClick = useCallback(
    (controller: IConcretingControllerDate) => {
      setConcretingControllerDate(controller);
    },
    [setConcretingControllerDate]
  );

  return (
    <Styled.Container>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <ConcretingButton
            title={t(ConcretingMessages.pastText)}
            active={concretingControllerDate === "past"}
            onClick={() => handleClick("past")}
          />
        </Grid>
        <Grid item xs={4}>
          <ConcretingButton
            title={t(ConcretingMessages.todayText)}
            active={concretingControllerDate === "today"}
            onClick={() => handleClick("today")}
          />
        </Grid>
        <Grid item xs={4}>
          <ConcretingButton
            title={t(ConcretingMessages.futureText)}
            active={concretingControllerDate === "future"}
            onClick={() => handleClick("future")}
          />
        </Grid>
      </Grid>
    </Styled.Container>
  );
};

export default ConcretingButtons;
